import React, { useState } from 'react';
import Section from '../components/Section';
import PrimaryButton from '../components/PrimaryButton';
import '../components/CardGrid.css';
import '../components/Forms.css';
import './ServicePage.css';
import {
  FaLinkedinIn,
  FaXTwitter,
  FaFacebookF,
  FaInstagram
} from 'react-icons/fa6';

const CustomRAGModels = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const response = await fetch('https://mokesh.pythonanywhere.com/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          service: 'Custom RAG Models'
        }),
      });

      if (response.ok) {
        setSubmitMessage("Thank you! We've sent you a confirmation email.");
        setFormData({ name: '', email: '', organization: '', message: '' });
      } else {
        throw new Error();
      }
    } catch {
      setSubmitMessage('Sorry, there was an error sending your message.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* ================= OVERVIEW ================= */}
      <Section
        eyebrow="Custom RAG Models"
        title="Retrieval-augmented generation setups."
        subtitle="RAG systems that combine vector search, structured retrieval, and guardrails to answer questions on your documents and APIs."
      >
        <div className="service-layout">

          {/* LEFT */}
          <div className="service-text">
            <h3 className="service-heading">Advanced RAG Implementation</h3>
            <p>
              State-of-the-art retrieval-augmented generation systems that deliver
              accurate, contextual answers grounded in your proprietary knowledge.
            </p>

            <div className="service-block">
              <h4>RAG Components</h4>
              <ul>
                <li>Document ingestion and preprocessing</li>
                <li>Vector embeddings and indexing</li>
                <li>Semantic search and retrieval</li>
                <li>Context-aware answer generation</li>
                <li>Source attribution and citations</li>
              </ul>
            </div>

            <div className="service-block">
              <h4>Supported Data Sources</h4>
              <ul>
                <li>PDF documents and reports</li>
                <li>Web pages and articles</li>
                <li>Structured databases and APIs</li>
                <li>Internal documentation and wikis</li>
                <li>Code repositories and technical docs</li>
              </ul>
            </div>

            <div className="service-block">
              <h4>Advanced Features</h4>
              <ul>
                <li>Multi-modal RAG (text, images, tables)</li>
                <li>Conversational memory and long context</li>
                <li>Fact-checking and hallucination prevention</li>
                <li>Domain-specific fine-tuning</li>
                <li>Real-time knowledge updates</li>
              </ul>
            </div>
          </div>

          {/* RIGHT */}
          <div className="service-visual">
            <img
src="https://airobohub.com/wp-content/uploads/2024/08/bot8.jpeg"

              alt="Custom RAG Models"
              className="service-image"
            />
          </div>

        </div>
      </Section>

      {/* ================= CONTACT ================= */}
      <Section
        eyebrow="Service enquiry"
        title="Let’s design something impactful."
        subtitle="Share your requirements and our team will reach out within 24 hours."
        align="left"
      >
        <div className="split-section">
          <div className="split-left slide-up">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Organization</label>
            <input
              type="text"
              name="organization"
              value={formData.organization}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Message *</label>
            <textarea
              rows="5"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <PrimaryButton type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Enquiry'}
          </PrimaryButton>

          {submitMessage && (
            <p
              className={`submit-message ${
                submitMessage.includes('Thank you') ? 'success' : 'error'
              }`}
            >
              {submitMessage}
            </p>
          )}
        </form>
          </div>
                    <div className="split-right card-grid animate-stagger">

            <div className="card glow-card">
              <h3 className="card-title">Connect With Us</h3>
              <p className="card-body">
                Follow us for updates, insights, and announcements.
              </p>

<div className="social-icons">
  <a
    href="https://www.linkedin.com/company/tempesthub/"
    target="_blank"
    rel="noreferrer"
    aria-label="LinkedIn"
  >
    <FaLinkedinIn />
  </a>

  <a
    href="https://x.com/Tempest_hub"
    target="_blank"
    rel="noreferrer"
    aria-label="X (Twitter)"
  >
    <FaXTwitter />
  </a>

  <a
    href="https://www.facebook.com/profile.php?id=61586259132683"
    target="_blank"
    rel="noreferrer"
    aria-label="Facebook"
  >
    <FaFacebookF />
  </a>

  <a
    href="https://www.instagram.com/tempest.hub?igsh=MXd2dDI5ZDZhNDVlZw=="
    target="_blank"
    rel="noreferrer"
    aria-label="Instagram"
  >
    <FaInstagram />
  </a>
</div>
            </div>

            <div className="card glow-card">
              <h3 className="card-title">Email Us</h3>
              <p className="card-body">
                Reach out directly for partnerships, training, or project discussions.
              </p>

              <a href="mailto:info@tempesthub.in" className="email-link">
                info@tempesthub.in
              </a>
            </div>

          </div>
        </div>
      </Section>
    </>
  );
};

export default CustomRAGModels;
